import React, { useState, useEffect, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";

import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import SuccessPopupModal from "../../components/SuccessPopupModal";
import { addUpdateBlog, GetBlogModal } from "../../../Services/Blog/BlogApi";
import { ERROR_MESSAGES } from "../../components/GlobalMassage";
import { useAuth } from "../../../Context/AuthContext";
import { addUpdateCareer, GetCareerModelData } from "../../../Services/Career/CareerApi";
// import { AddUpdateProject, GetProjectModel } from 'services/Project/ProjectApi';
// import Text_Editor from "./Text_Editor";
// import { ERROR_MESSAGES } from "../components/GlobalMassage";
// import { addUpdateBlog, GetBlogModal } from "../../Services/Blog/BlogApi";
// import { useAuth } from "../../Context/AuthContext";
// import SuccessPopupModal from "../components/SuccessPopupModal";

const CareerAddUpdateModal = ({
  show,
  onHide,
  setIsAddUpdateActionDone,
  modelRequestData,
}) => {
  const [modelAction, setModelAction] = useState("");
  const [error, setErrors] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const { setLoader, user } = useAuth()
  const [stateOption, setStateOption] = useState([]);
  const [companyOption, setCompanyOption] = useState([]);
  const [districtOption, setDistrictOption] = useState([]);
  const [talukaOption, setTalukaOption] = useState([]);
  const [villageOption, setVillageOption] = useState([]);

  const [careerObj, setCareerObj] = useState({
    careerKeyID: null,
    position: null,
    workStatus: null,
    qualification: null,
    experience: null,
    location: null,
    description: null,
  });

 
  useEffect(() => {
    // debugger
    if (modelRequestData?.Action === 'Update') {
      if (modelRequestData?.CareerKeyID !== null) {
        GetBlogModalData(modelRequestData.CareerKeyID);
      }
    }
  }, [modelRequestData?.Action]);


  const AddCustomerBtnClick = async () => {
    // debugger
    let isValid = false;

    if (
      careerObj.position === null ||
      careerObj.position === undefined ||
      careerObj.position === "" ||

      careerObj.workStatus === null ||
      careerObj.workStatus === undefined ||
      careerObj.workStatus === "" ||

      careerObj.qualification === null ||
      careerObj.qualification === undefined ||
      careerObj.qualification === "" ||

      careerObj.experience === null ||
      careerObj.experience === undefined ||
      careerObj.experience === "" ||

      careerObj.location === null ||
      careerObj.location === undefined ||
      careerObj.location === "" ||

     



      careerObj.description === undefined ||
      careerObj.description === null ||
      careerObj.description === "" 

     
    ) {
      setErrors(true);
      isValid = true;
    }  else {
      setErrors(false);
      isValid = false;
    }


    const apiParam = {
      careerKeyID: careerObj.careerKeyID,
      position: careerObj.position,
      workStatus: careerObj.workStatus,
      qualification: careerObj.qualification,
      experience: careerObj.experience,
      location: careerObj.location,
      description: careerObj.description,
  

    };
    if (!isValid) {
      AddUpdateCustomerData(apiParam);
    }
  };

  const AddUpdateCustomerData = async (apiParam) => {
    // debugger
    setLoader(true);
    try {
      let url = '/addUpdateCareer'; // Default URL for Adding Data

      const response = await addUpdateCareer(url, apiParam);
      if (response) {
        if (response?.data?.statusCode === 200) {
          setLoader(false);
          // debugger
          setShowSuccessModal(true);
          setModelAction(
            modelRequestData.Action === null || modelRequestData.Action === undefined
              ? 'Career Added Successfully!'
              : ' Career Updated Successfully!'
          ); //Do not change this naming convention

          setIsAddUpdateActionDone(true);
        } else {
          setLoader(false);
          setErrorMessage(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };


 
  const GetBlogModalData = async (id) => {

    setLoader(true);
    if (id === undefined) {
      return;
    }

    try {
      const data = await GetCareerModelData(id);
      if (data?.data?.statusCode === 200) {
        setLoader(false);

        console.log(data, 'dsadas324r');
        const ModelData = data.data.responseData.data; // Assuming data is an array
        console.log(ModelData.Title, 'dsaiygd9s7a6ydsadsa');

        setCareerObj({
          ...careerObj,
          careerKeyID: ModelData.CareerKeyID,
          position: ModelData.Position,
          workStatus: ModelData.WorkStatus,
          qualification: ModelData.Qualification,
          experience: ModelData.Experience,
          location: ModelData.Location,
          description: ModelData.Description,
          

        });

      } else {
        setLoader(false);
        // Handle non-200 status codes if necessary
        console.error('Error fetching data: ', data?.data?.statusCode);
      }
    } catch (error) {
      setLoader(false);
      console.error('Error in Customer : ', error);
    }
  };

  console.log(careerObj.Title, 'kdjsgauhydsa');

  const closeAllModal = () => {
    onHide();
    setShowSuccessModal(false);
  };

  




  
  return (
    <>
    {show && <div className="custom-backdrop" />}
      <Modal
        size="lg"
        show={show}
        style={{ zIndex: 1300 }}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="text-center text-dark">
              {modelRequestData?.Action !== null
                ? "Update Career"
                : modelRequestData?.Action === null
                  ? "Add Career"
                  : ""}
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "55vh", overflow: "overlay" }}>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="Position" className="form-label">
                    Position
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="Position"
                    placeholder="Enter Position"
                    aria-describedby="Employee"
                    value={careerObj.position}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setCareerObj((prev) => ({
                        ...prev,
                        position: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                    (careerObj.position === null ||
                      careerObj.position === undefined ||
                      careerObj.position === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="clientName" className="form-label">
                    Work Status
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="clientName"
                    placeholder="Enter Work Status"
                    aria-describedby="Employee"
                    value={careerObj.workStatus}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setCareerObj((prev) => ({
                        ...prev,
                        workStatus: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                    (careerObj.workStatus === null ||
                      careerObj.workStatus === undefined ||
                      careerObj.workStatus === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              
            </div>
            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="Qualification" className="form-label">
                Qualification
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="Qualification"
                    placeholder="Enter Qualification"
                    aria-describedby="Employee"
                    value={careerObj.qualification}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setCareerObj((prev) => ({
                        ...prev,
                        qualification: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                    (careerObj.qualification === null ||
                      careerObj.qualification === undefined ||
                      careerObj.qualification === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="Experience" className="form-label">
                    Experience
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="Experience"
                    maxLength={2}
                    placeholder="Enter Experience"
                    aria-describedby="Employee"
                    value={careerObj.experience}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                    
                      // Allow only digits
                      const cleanedValue = inputValue.replace(/[^0-9]/g, "");
                    
                      setCareerObj((prev) => ({
                        ...prev,
                        experience: cleanedValue,
                      }));
                    }}
                    />

                  {error &&
                    (careerObj.experience === null ||
                      careerObj.experience === undefined ||
                      careerObj.experience === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              
            </div>
            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="Location" className="form-label">
                    Location
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="Location"
                    placeholder="Enter Location"
                    aria-describedby="Employee"
                    value={careerObj.location}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setCareerObj((prev) => ({
                        ...prev,
                        location: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                    (careerObj.location === null ||
                      careerObj.location === undefined ||
                      careerObj.location === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="Description" className="form-label">
                    Description
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    type="textarea"
                    className="form-control"
                    id="Description"
                    placeholder="Enter Description"
                    aria-describedby="Employee"
                    value={careerObj.description}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setCareerObj((prev) => ({
                        ...prev,
                        description: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                    (careerObj.description === null ||
                      careerObj.description === undefined ||
                      careerObj.description === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              
            </div>
          
            



            {/* <div className="row"> */}
          </div>
         

          {/* </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button className="rts-btn border bg-transparent" onClick={onHide}>
            Close
          </Button>
          <Button
            type="submit"
            style={{
              color: "white",
              backgroundColor: "#blue",
              borderColor: "#f08143",
            }}
            className=" rts-btn    text-center"
            onClick={() => AddCustomerBtnClick()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {showSuccessModal && (
        <SuccessPopupModal
          show={showSuccessModal}
          onHide={() => closeAllModal()}
          setShowSuccessModal={setShowSuccessModal}
          modelAction={modelAction}
        />
      )}
    </>
  );
};

export default CareerAddUpdateModal;


